export default __webpack_public_path__ + "static/media/repository.476d9835.svg";